import { apiSlice } from "./apiSlice";
export const contactsSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getAllContacts: builder.query({
            query: (params) => ({
                url: `Account/contacts/list`,
                params,
            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
            providesTags: ["AllContacts"],
        }),
    }),
});

export const { useGetAllContactsQuery } = contactsSlice;
